import React from 'react';
import { Card, CardMedia } from 'react-toolbox/lib/card';

const ImageCard = ({ value, style }) => {
  return (
    value &&
    <Card style={{ justifyContent: 'center', ...style }}>
      <CardMedia image={value} aspectRatio="square" />
    </Card>
  );
};

export default ImageCard;



// WEBPACK FOOTER //
// ./src/App/join/Templates/Elements/ImageCard.js